import { useCallback, useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import Grid from '@mui/material/Grid2';
import { Box, Button, Divider, Paper, Typography } from '@mui/material';
import { Settings } from '../../../interfaces/Settings/Settings';
import { getSettingsByType, upsertSettings } from '../../../api/Settings';
import { SettingsType } from '../../../interfaces/Settings/SettingsType';
import { GenericSettingsValue } from '../../../interfaces/Settings/GenericSettingsValue';
import { getSettingsValue, getUpdatedSettings } from '../../../utils/Settings';
import { Waiting } from '../../../components/Waiting/Waiting';
import { SettingsRow } from '../../../components/Settings/SettingsRow';
import { SettingsValueType } from '../../../interfaces/Settings/SettingsValueType';
import { sharedStyles } from '../../../utils/Style';

export const PricingSettings = () => {
  const [settings, setSettings] = useState<Settings[]>([]);
  const [loading, setLoading] = useState(true);

  const refreshSettings = () => {
    setLoading(true);
    getSettingsByType(SettingsType.PRICE_ROUNDING)
      .then((s) => setSettings(s))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    refreshSettings();
  }, []);

  const handleChange = useCallback(
    (key: string, newValue: GenericSettingsValue) =>
      setSettings(
        getUpdatedSettings(
          SettingsType.PRICE_ROUNDING,
          key,
          settings,
          newValue,
        ),
      ),
    [settings],
  );

  const handleSave = () => {
    setLoading(true);
    upsertSettings(settings)
      .then(() => {
        toast.success('Ayarlar başarıyla kaydedildi');
        refreshSettings();
      })
      .catch((err) => {
        toast.error(err.message);
        setLoading(false);
      });
  };

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, lg: 6 }}>
        <Paper
          sx={{
            p: 1.5,
            display: 'flex',
            flexDirection: 'column',
            gap: 1.5,
            height: '95%',
          }}
        >
          <Waiting open={loading} />
          <Typography
            sx={{
              ...sharedStyles.h5,
              fontWeight: 'bold',
            }}
          >
            Fiyat Yuvarlama
          </Typography>
          <Divider />

          <SettingsRow
            name='Aktif'
            valueType={SettingsValueType.BOOLEAN}
            value={getSettingsValue(settings, 'price_fraction_enabled')}
            onChange={(newValue) =>
              handleChange('price_fraction_enabled', newValue)
            }
          />
          <SettingsRow
            name='Virgülden Sonra Yuvarlanacak Değer'
            valueType={SettingsValueType.NUMBER}
            value={getSettingsValue(settings, 'price_fraction')}
            onChange={(newValue) => handleChange('price_fraction', newValue)}
            minValue={1}
            maxValue={99}
          />

          <Box sx={{ display: 'flex', flexGrow: 1 }} />
          <Box display='flex' justifyContent='flex-end'>
            <Button
              variant='contained'
              onClick={handleSave}
              sx={{ ...sharedStyles.buttonText, mt: 1.5 }}
            >
              Kaydet
            </Button>
          </Box>
        </Paper>
      </Grid>
    </Grid>
  );
};
